import * as React from 'react'
import PropTypes from 'prop-types'
import IconSold from '../IconSold'
import isSellable from '../../helpers/product/isSellable'
import isOnSale from '../../helpers/product/isOnSale'
import isNewArrivals from '../../helpers/product/isNewArrivals'
import isGIA from '../../helpers/product/isGIA'
import hasBoxAndPapers from '../../helpers/product/hasBoxAndPapers'

export const TAG_SELLABLE = 'sellable'
export const TAG_NEW = 'new'
export const TAG_SALE = 'sale'
export const TAG_GIA = 'GIA'
export const TAG_BOX_AND_PAPERS = 'box_and_papers'
export const AllowedTags = [TAG_SELLABLE, TAG_NEW, TAG_SALE, TAG_BOX_AND_PAPERS, TAG_GIA]

const Tag = ({
  name,
  className = 'hidden nth-1:block support-hover:nth-2:block text-gray-500 border-gray-300 ',
}) => (
  <div
    className={
      'max-w-max text-xs sm:text-sm lg:text-base border bg-white px-3 text-center font-bold  relative top-3 left-3 group-hover:translate-x-0 support-hover:-translate-x-full duration-300 ' +
      className
    }
  >
    {name}
  </div>
)

const Tags = ({ product, tags }) => {
  const checkTag = name => {
    return tags === true || (tags && tags.includes(name))
  }
  const canBuy = checkTag(TAG_SELLABLE) ? isSellable(product) : true
  const gia = checkTag(TAG_GIA) ? isGIA(product) : false
  const boxAndPapers = checkTag(TAG_BOX_AND_PAPERS) ? hasBoxAndPapers(product) : false
  const newArrivals = checkTag(TAG_NEW) ? isNewArrivals(product) : false
  const onSale = checkTag(TAG_SALE) ? isOnSale(product) : false
  if (!canBuy)
    return (
      <div className="absolute pointer-events-none top-0 left-0 z-10 flex h-full w-full items-center justify-center border bg-white bg-opacity-60 px-3 text-center font-black backdrop-blur-[1px] backdrop-saturate-[50%] ">
        <IconSold className="z-20 w-1/2 fill-current text-black" />
        <div className="absolute top-[50%] w-1/2 -translate-y-[50%] rounded-full bg-white p-14 opacity-70 blur-lg">
          {' '}
        </div>
      </div>
    )
  if (gia || boxAndPapers || newArrivals || onSale) {
    return (
      <div className={'absolute z-10 flex flex-col top-0 left-0 gap-2 '}>
        {onSale && (
          <Tag
            name="SALE"
            className={'hidden nth-1:block support-hover:nth-2:block text-red-600 border-red-600'}
          />
        )}
        {boxAndPapers && (
          <Tag
            name="BOX & PAPERS"
            className={
              'hidden nth-1:block support-hover:nth-2:block text-green-700 border-green-700'
            }
          />
        )}
        {gia && (
          <Tag
            name="GIA"
            className={'hidden nth-1:block support-hover:nth-2:block text-blue-700 border-blue-700'}
          />
        )}
        {newArrivals && <Tag name="NEW ARRIVAL" />}
      </div>
    )
  }
  return null
}
Tag.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
}
Tags.propTypes = {
  product: PropTypes.object,
  tags: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOf(AllowedTags))]),
}

export default Tags
